import { Base } from '@app/shared/models/base.model'
import { User } from '@app/modules/user/user.model'

export class Probability extends Base {
  uuid: string = null
  name: string = null
  value: number = null
  displayOrder: number = null
  // ---------------------------------------------------------------------------
  createdAt: Date = null
  updatedAt: Date = null
  deletedAt: Date = null
  createdByUuid: string = null
  createdByUser: User = null
  updatedByUuid: string = null
  updatedByUser: User = null

  /**
   * Properties with type Date
   *
   * @type {Array<string>}
   */
  protected _dates: Array<string> = [
    'createdAt',
    'updatedAt',
    'deletedAt',
    'dob'
  ]

  /**
   * Constructor
   *
   * @param {Partial<Probability>} data Initial values
   */
  public constructor (data?: Partial<Probability>) {
    super(data)
    this.init(data)
  }
}
